export type RegionIds = "local" | "au" | "uk";

export const REGION_ORIGINS: Record<RegionIds, string> = {
  local: import.meta.env.VITE_API_LOCAL_ORIGIN,
  au: import.meta.env.VITE_API_AU_ORIGIN,
  uk: import.meta.env.VITE_API_UK_ORIGIN,
};
